import { t } from '../../i18n';
import { cn } from '../lib/utils';

// The brand until the Client registers a name (design system §7): the one place the real logo will replace.
export function Wordmark({ size = 'md' }: { size?: 'md' | 'lg' }) {
  return (
    <span className={cn('font-sans font-semibold', size === 'lg' ? 'text-2xl' : 'text-lg')}>
      {t('components.Wordmark.text')}
    </span>
  );
}
